import React from 'react';
import s from './Literature.scss';
const LiteratureThumbReactView = ({ width, height, deviation })=>/*#__PURE__*/ React.createElement("span", {
        className: s['root'],
        style: {
            width,
            height
        }
    }, deviation.title);
LiteratureThumbReactView.displayName = 'LiteratureThumbReactView';
export default LiteratureThumbReactView;

//# sourceMappingURL=Literature.js.map